import { render, staticRenderFns } from "./upTower.vue?vue&type=template&id=63c7a9ba&scoped=true&"
import script from "./upTower.vue?vue&type=script&lang=js&"
export * from "./upTower.vue?vue&type=script&lang=js&"
import style0 from "./upTower.vue?vue&type=style&index=0&id=63c7a9ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c7a9ba",
  null
  
)

export default component.exports